module.exports = __webpack_public_path__ + "static/assets/9cc1069f13e719badf127b5917fdf337.png";